import { render, staticRenderFns } from "./BuyBoxTypeSwitcher.vue?vue&type=template&id=7a4c28ee&scoped=true"
import script from "./BuyBoxTypeSwitcher.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxTypeSwitcher.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxTypeSwitcher.vue?vue&type=style&index=0&id=7a4c28ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4c28ee",
  null
  
)

export default component.exports